var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-webdev-box"},[_c('div',{staticClass:"mobile-en-title"},[_vm._v(_vm._s("Website".toUpperCase()))]),_c('div',{staticClass:"mobile-cn-title"},[_vm._v("高端网站定制开发")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.cleanHtmlText(_vm.data.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }